import React from "react";
import { getIcon } from "./icon";
import ic from "./Icons.module.scss";

interface IconsName {
  iconName: string;
  clicked?: () => void;
}
type IconType = ReturnType<typeof getIcon>;

/************************
 * Icons
 * getIcon must have something to return, otherwise typescript will complain
 **********************/
export default function Icons({ iconName, clicked }: IconsName) {
  const icon: IconType = getIcon(iconName);
  return (
    <div className={ic.buttonicon} onClick={clicked}>
      {icon}
    </div>
  );
}
